<template>
    <b-container fluid class="p-3">
        <b-row>
            <b-col>
                <h1><t fonts.title /></h1>

                <b-button class="m-2" @click="newFont()"><t fonts.new /></b-button>

                <b-table
                    sticky-header="600px"
                    striped
                    head-variant="light"
                    responsive="sm"
                    hover
                    selectable
                    select-mode="single"
                    :items="fonts"
                    :filter="filter"
                    @row-selected="onRowSelected"
                    :fields="fields">

                    <template v-slot:cell(sample)="data">
                        <svg height="1.7em" viewBox="-20 -20 1000 150" v-html="data.item.sample" />
                    </template>

                </b-table>
            </b-col>
            <b-col>
                <div v-if="form">
                    <b-form  @submit="onSubmit" @reset="onReset" >
                        <b-form-checkbox
                            class="mb-2"
                            id="input-active"
                            v-model="form.active"
                            switch
                            size="lg"
                            :value="true"
                            :unchecked-value="false"
                        >
                            <t fonts.active v-if="form.active" />
                            <t fonts.inactive v-else />
                        </b-form-checkbox>

                        <b-form-group :label="$t('fonts.sample')" label-for="svg-sample" v-if="selected">
                            <svg id="svg-sample" height="4em" viewBox="-20 -20 1000 150" v-html="form.sample" />
                        </b-form-group>

                        <b-form-group :label="selected ? $t('fonts.modify') : $t('fonts.select')" label-for="input-file">
                            <b-form-file
                                id='input-file'
                                accept=".svg"
                                v-model="form.file"
                                :placeholder="$t('fonts.svgformat')"
                                :browse-text="$t('common.choose')">
                                <template slot="file-name" slot-scope="{ names }">
                                    <b-badge variant="dark">{{ names[0] }}</b-badge>
                                </template>

                            </b-form-file>
                        </b-form-group>

                        <b-form-group :label="$t('fonts.name')" label-for="input-name" >

                            <b-alert variant="success" show v-if="!selected">
                                <t fonts.deducted /><br/><t fonts.usedashforspace />
                            </b-alert>
                            <b-alert variant="warning" show v-if="!selected">
                                <t fonts.nameisreadonly />
                            </b-alert>

                            <b-form-input
                                v-if="selected"
                                id="input-name"
                                disabled
                                v-model="form.name"
                                required
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group :label="$t('fonts.type')" label-for="input-type">
                            <b-form-select
                                id="input-type"
                                v-model="form.type"
                                :options="types"
                                required
                            ></b-form-select>
                        </b-form-group>


                        <b-button type="submit" variant="primary" class="mr-2"><t common.save /></b-button>
                        <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                    </b-form>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    /* eslint-disable vue/no-unused-components */
import { BContainer, BRow, BCol, BTable, BForm, BFormGroup, BFormInput, BFormFile, BButton, BFormCheckbox, BAlert, BFormSelect, BBadge } from 'bootstrap-vue'
import { models } from 'feathers-vuex';
import Api from '@/services/Api';

export default {
    components: {
        BContainer,
        BRow,
        BCol,
        BTable,
        BForm,
        BFormGroup,
        BFormInput,
        BFormFile,
        BButton,
        BFormCheckbox,
        BAlert,
        BFormSelect,
        BBadge
    },
    data() {
        return {
            fields: [
                {
                    key: 'active',
                    label: 'Active',
                    sortable: true
                },
                {
                    key: 'name',
                    label: 'Nom',
                    sortable: true
                },
                {
                    key: 'type',
                    label: 'Type',
                    sortable: true
                },
                {
                    key: 'sample',
                    label: 'Exemple',
                    sortable: false
                }
            ],
            filter: null,
            fonts: [],
            form: null,

            types: ['cut', 'material'],
            selected: []
        }
    },
    async mounted() {
        await this.refreshFonts();
    },
    methods: {

        async refreshFonts() {
            let blockSize = 20;
            let response = await models.api.Font.find({query: {$limit: blockSize}});
            this.fonts = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Font.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.fonts = this.fonts.concat(response.data);
            }

        },
        newFont() {
            this.selected = null;

            this.form = {
                name: '',
                active: false,
                type: 'material',
                file: null,
                sample: null
            }
        },
        onRowSelected(items) {
            this.selected = items.length > 0 ? items[0] : null;
            if (this.selected) {
                this.form = {
                    name: this.selected.name,
                    active: this.selected.active,
                    type: this.selected.type,
                    sample: this.selected.sample,
                    file: null
                }
            } else {
                this.form = null;
            }
        },
        async onSubmit(evt) {
            evt.preventDefault()
            try {
                if (this.selected) {
                    if (this.form.file) {

                        let formData = new FormData();
                        formData.append('files', this.form.file);

                        await Api().patch(
                            '/fonts/' + this.selected._id,
                            formData,
                            {
                                headers: {
                                    'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        );
                        this.form.file = null;
                    }

                    this.selected.active = this.form.active;
                    this.selected.type = this.form.type;

                    await this.selected.save();

                } else {
                    if (this.form.file) {
                        let formData = new FormData();
                        formData.append('files', this.form.file);
                        formData.append('type', this.form.type);

                        await Api().post(
                            '/fonts',
                            formData,
                            {
                                headers: {
                                    'Authorization': `Bearer ${window.localStorage.getItem('feathers-jwt')}`,
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        );
                    }
                }

                this.refreshFonts();
            } catch (err) {
                console.error(err);
            }
        },
        onReset(evt) {
            evt.preventDefault()
            this.form = null;
        }
    }
}
</script>
